import { Rect } from "../.././MyHelpers";
import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { ExpandingWildsBulk, ExpandingWildsBulkConfig, ExpandingWildsBulkFactory, ExpandingWildsBulkParam } from "../../slot/ExpandingWildBulk";
import { RewardColor } from "../../slot/ScatterRandomAward/RewardOptionFactory";
import { SlotGameInitData } from "../../SlotGameInitData";
import { FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { ChangeSpeedParams, SlotGameType1 } from "../SlotGameType1";
// namespace SlotGames
// namespace SlotGames
// {

	export class SweetBlast extends SlotGameType1 
	{

		//protected override freegameBonusFactory: FreegameBonusFactory = new SweetBlastFreegameBonusFactory();
		
		//protected panelFactory:IPanelFactory = new SweetBlastPanelFactory();
		protected override helpFactory:IHelpFactory = new SweetBlastHelpFactory();

		//SEND COLOR FOR RSA 
        protected override color: RewardColor = 
        {
            color: "#F1F0C9",
		    coloroutherStroke: "black",
            colorinnerStroke: "#9F8DF4",
        }

		//LED COLOR
		protected override ColorLed:string="173,83,255\n";
		
		protected override pickBonusFactory: PickBonusFactory = new SweetBlastPickBonusFactory();
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "SweetBlast");

			
			this.spinnableReelsParams.topBorderWidth = 10;
			this.spinnableReelsParams.bottomBorderWidth = 10;
		}
	}

	// class SweetBlastFreegame extends FreegameBonus
	// {
	// 	public constructor(gameName: string, params: FreegameBonusParams ) {
	// 		super(gameName, params);
	// 		this.spinnableReelsParams.topBorderWidth = 10;
	// 		this.spinnableReelsParams.bottomBorderWidth = 10;
	// 	}
		

	// 	public override OnPicked(index: number): void {
	// 		//super.OnPicked(index);

	// 		if (this.stateMachine.State() == FreegameStates.Pick)
	// 		{
	// 			// Log.Debug(this.logGroup, "Picked index " + index);
	
	// 			// TODO check state, check index bounds
	// 			this.pickedIndex = index;
	// 			// protocol.Send("SelectBonusElement",{selectedElement: index});
	
	// 			for (let i = 0; i < this.picks.length; i++) {
	// 				if (i == index) {
	// 					this.picks[i].BringToFront();
	// 					this.picks[i].awardElem.style.fontSize = "90px";
	// 					this.picks[i].awardElem.style.left = "-7px";
	// 					this.picks[i].awardElem.style.top = "4px";
	// 				}
	// 				else {
	// 					this.picks[i].PushToBack();
	// 					this.picks[i].awardElem.style.fontSize = "50px";
	// 					this.picks[i].awardElem.style.left = "-7px";
	// 					this.picks[i].awardElem.style.top = "4px";
	// 				}
	// 			}
	
	// 			this.stateMachine.ChangeState(FreegameStates.RevealPicked);
	// 		}
	// 	}
	

	// 	protected override PrepareFonts(resourceManager: ResourceManager): void 
	// 	{
	// 		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
	// 		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "CuteJellyfish.ttf", "." + this.resid.ScopedResourceName("font")));
	// 	}

	// 	protected override PicksPositions(): FreegamePickElemGeometry[] 
	// 	{
	// 		// align award to be in the box, when box opens
	// 		let geometry: FreegamePickElemGeometry[] = [];

	// 		let displayWidth: number = 500;
	// 		let displayHeight: number = 500;

	// 		let displayRects: PixelRect[] = 
	// 		[
	// 			new PixelRect(0, 290, displayWidth, displayHeight),
	// 			new PixelRect(331, 575, displayWidth, displayHeight),
	// 			new PixelRect(665, 290, displayWidth, displayHeight),
	// 			new PixelRect(999, 575, displayWidth, displayHeight),
	// 			new PixelRect(1323, 290, displayWidth, displayHeight),
	// 		];

	// 		// offset relative to pick rect
	// 		let pickRect = new PixelRect(48, 81, 405, 340);
			
	// 		let awardRect = new PixelRect(0, 0, displayWidth, displayHeight);
			
	// 		for (let i = 0; i < displayRects.length; i++) 
	// 		{
	// 			geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect, awardRect));
	// 		}

	// 		return geometry;
	// 	}

	// 	//CREATE FOR ROTATE ONLY THE PICK ELEMENT
	// 	protected override PicksLoaded(resourceManager: IReadOnlyResourceManager): void {

	// 		let pickGeometries: FreegamePickElemGeometry[] = this.PicksPositions();
	// 		this.canvasSprite = null;
	
	// 		for (let i = 0; i < 5; i++) {
	
	// 			let sprite: Sprite = resourceManager.Get<SpriteResource>(this.resid.Add("pick")).sprite.Copy();
	// 			//let canvasSprite: CanvasSprite = new CanvasSprite(sprite, pickGeometries[i].displayRect.Size());
	// 			this.canvasSprite = new CanvasSprite(sprite, pickGeometries[i].displayRect.Size());
	
	// 			let params: FreegamePickElementParams = new FreegamePickElementParams(
	// 				i, 
	// 				this.logGroup,
	// 				pickGeometries[i].displayRect, 
	// 				pickGeometries[i].pickRect, 
	// 				pickGeometries[i].awardRect, 
	// 				this.canvasSprite
	// 			);
					
	// 			let pick: FreegamePickElement = this.params.pickElementFactory.CreatePickElement(params);
	// 			//ROTATE PICK FOR FILL IMG
	// 			//pick.pickElem.style.transform="rotate(45deg)";
	// 			pick.AddPickCallback((index: number) => this.OnPicked(index));
	// 			pick.AddFreegamePickAwardDisplayedCallback((index: number) => this.OnAwardRevealed(index));
	// 			pick.AddRemainingDisplayedCallback((index: number) => this.OnRemainingRevealed(index));
	
	// 			pick.OnDisplayAwardCallback = () => this.audio.Play(this.resid.ScopedResourceName("pick"));
	// 			pick.OnDisplayRemainingCallback = () => this.audio.Replay(this.resid.ScopedResourceName("remaining"));
	
				
	// 			this.picks.push(pick);
	// 			this.picksContainer.appendChild(pick.View());
				
	// 		}
	// 	}
		

	// 	// protected PrepareMessage(resourceManager: ResourceManager)
	// 	// {
	// 	// 	super.PrepareMessage(resourceManager);
	// 	// }
	// }


	class SweetBlastPickBonus extends PickBonus
	{
		public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
			throw new Error("Method not implemented.");
		}
	}

	class SweetBlastPickBonusElement extends PickBonusElement
	{
	}
	


	class SweetBlastFreegamePickElement extends FreegamePickElement
	{
		public override AwardElemePrepare()
		{
			super.AwardElemePrepare();
			this.awardElem.style.left = "-4px";
			this.awardElem.style.top = "2px";
			this.awardElem.style.fontSize ="150px";
			
		}

		protected override PreparePickedElement(): void
		{
			this.awardElem.style.color = "white";
			this.awardElem.style.fontSize = "150px";
			this.awardElem.style.fontWeight="bold";
		}

		protected override PrepareRemainingElement(): void
		{
			this.awardElem.style.removeProperty("color");
			this.awardElem.style.removeProperty("fontSize");
		}
	}

	//Panel Colorized
	class SweetBlastPanelFactory implements IPanelFactory
	{
		public CreateNewPanel(params: PanelParams):Panel
		{
			return new SweetBlastPanel(params);
		}
	}

	class SweetBlastPanel extends Panel
	{
		protected override ButtonBackground():ButtonColors
		{
			let color:ButtonColors ={
				backgroundButtonColor: "linear-gradient(rgb(28, 3, 38),rgb(115, 6, 77), rgb(217, 108, 159),rgb(115, 6, 77),rgb(28, 3, 38)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				linearColor:"linear-gradient(to left , transparent, LightPink,transparent ) 0 10 100%",
			};
			
			return color;
		}

	}

	class SweetBlastHelpFactory implements IHelpFactory
	{
		public CreateNewHelp(params: HelpParameters):Help
		{
			return new SweetBlastHelp(params);
		}
	}

	class SweetBlastHelp extends Help
	{
		protected override BackgroundPanel():HelpPanelColor
		{
			let color:HelpPanelColor = {
				backgroundPanelColor: "linear-gradient(rgb(28, 3, 38),rgb(115, 6, 77), rgb(217, 108, 159),rgb(115, 6, 77),rgb(28, 3, 38)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			};

			return color;
		}
	}


	// class SweetBlastFreegameBonusFactory extends FreegameBonusFactory
	// {
	// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus 
	// 	{
	// 		return new SweetBlastFreegame(gameName, params);
	// 	}
		
		
	// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement 
	// 	{
	// 		return new SweetBlastFreegamePickElement(params);
	// 	}
		
	// }

	class SweetBlastPickBonusFactory extends PickBonusFactory
	{
		public override CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus 
		{
			return new SweetBlastPickBonus(gameName, params);
		}

		public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement 
		{
			return new SweetBlastPickBonusElement(params);
		}
		
	}
// }
